var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-modal',{ref:"modal",attrs:{"id":"print-transportation","title":"Print Transportation","ok-title":"Download","no-close-on-backdrop":true},on:{"ok":_vm.onDownload}},[_c('div',{staticClass:"text-center"},[_c('canvas',{attrs:{"id":"canvas","height":_vm.frameHeight,"width":_vm.frameWidth}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }